/* cg-r68.js (R67 work, Oct 29 2026). Loaded deferred from snippets/cg-r68-head.liquid.
   1. Thanksgiving pickup rules: Nov 26 only, 11:00 AM to 6:45 PM, same-day orders close at 2 PM (both time pickers).
   2. Thanksgiving slot caps (off until window.CG_R68.slotCaps.enabled is true).
   3. UTM / click-id capture to localStorage, cart attributes and every contact form.
   4. GA4 gift_card_click on the Toast eGift link.
   5. One rating everywhere (4.4, 2,200+ Google reviews).
   6. Reorder links (?cg_reorder=...) and the "Order again" strip for signed-in guests.
   7. Klaviyo onsite loaded after the first interaction. */
(function () {
  'use strict';
  if (window.__cgR68) return; window.__cgR68 = true;
  var C = window.CG_R68 || {};
  var TG = C.tg || { date: '2026-11-26', first: 660, last: 1125, step: 15, cutoff: 840 };
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(m) { var h = Math.floor(m / 60), mm = m % 60; return (h % 12 || 12) + ':' + pad(mm) + ' ' + (h >= 12 ? 'PM' : 'AM'); }
  function laNow() {
    var o = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { o[x.type] = x.value; });
    } catch (e) { var d = new Date(); return { day: d.toISOString().slice(0, 10), min: d.getHours() * 60 + d.getMinutes() }; }
    return { day: o.year + '-' + o.month + '-' + o.day, min: (+o.hour % 24) * 60 + (+o.minute) };
  }
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var rawFetch = (window.CG_R57 && window.CG_R57.rawFetch) || window.fetch.bind(window);
  function getCart() { return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function postJSON(u, b) { return rawFetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }); }

  /* ---------- 1 + 2. Thanksgiving pickup window ---------- */
  var tgCart = !!(window.CG_R57 && window.CG_R57.tg);
  function isTGItem(i) { return /thanksgiving/i.test((i.handle || '') + ' ' + (i.product_type || '')); }
  function refreshTG() { return getCart().then(function (c) { tgCart = (c.items || []).some(isTGItem); return tgCart; }).catch(function () { return tgCart; }); }
  function tgState() {
    var n = laNow();
    if (n.day > TG.date) return 'over';
    if (n.day === TG.date && n.min >= TG.cutoff) return 'closed';
    return 'open';
  }
  var CLOSED_MSG = 'Thanksgiving Feast orders are closed. Same-day orders stopped at 2 PM on Nov 26. Call (562) 907-7017 and we will do our best.';
  function fullSlots() { var s = C.slotCaps || {}; return (s.enabled && s.full) ? s.full.map(Number) : []; }
  function slotList(minFloor) {
    var out = [], full = fullSlots();
    for (var m = TG.first; m <= TG.last; m += TG.step) { if (m >= minFloor) out.push({ m: m, full: full.indexOf(m) > -1 }); }
    return out;
  }
  function floorToday() { var n = laNow(); return n.day === TG.date ? n.min + 30 : 0; }
  function fillTimes(sel, keep) {
    var list = slotList(floorToday()), html = '', firstOpen = null;
    list.forEach(function (s) {
      if (!s.full && firstOpen === null) firstOpen = s.m;
      html += '<option value="' + s.m + '"' + (s.full ? ' disabled' : '') + '>' + fmt(s.m) + (s.full ? ' (full)' : '') + '</option>';
    });
    sel.__cgR68 = true; sel.innerHTML = html; sel.__cgR68 = false;
    var want = +keep;
    var ok = list.some(function (s) { return s.m === want && !s.full; });
    sel.value = String(ok ? want : (firstOpen === null ? '' : firstOpen));
    return firstOpen;
  }
  function note(host, text, isErr) {
    if (!host) return;
    var p = host.querySelector('.cg-r68-tg');
    if (!p) { p = document.createElement('p'); p.className = 'cg-r68-tg'; host.appendChild(p); }
    var css = 'margin:10px 0 0;font-size:13px;line-height:1.4;color:' + (isErr ? '#a1260d' : '#7a3b00') + ';font-weight:' + (isErr ? '700' : '400');
    if (p.__css !== css) { p.__css = css; p.style.cssText = css; }
    if (p.textContent !== text) p.textContent = text;
  }
  function fullMsg(sel) {
    var full = fullSlots(); if (!full.length) return '';
    var want = +sel.getAttribute('data-r68-want');
    if (full.indexOf(want) < 0) return '';
    return 'This time is full, next available is ' + fmt(+sel.value) + '.';
  }
  function blockCheckout(on) {
    document.querySelectorAll('.cgm-checkout, #cgoc-sheet [data-go], [name="checkout"], #CartDrawer-Checkout, .cart__checkout-button').forEach(function (b) {
      if (on) { b.setAttribute('aria-disabled', 'true'); b.classList.add('cg-r68-blocked'); } else { b.removeAttribute('aria-disabled'); b.classList.remove('cg-r68-blocked'); }
    });
  }
  /* sheet used by the cart page (cg-core, R55b fills it with 10:00-6:30, we narrow it to 11:00-6:45) */
  function applySheet(sheet) {
    if (!tgCart || sheet.hidden) return;
    var ts = sheet.querySelector('[data-time]'); if (!ts || ts.__cgR68) return;
    var st = tgState();
    if (st !== 'open') { ts.__cgR68 = true; ts.innerHTML = ''; ts.__cgR68 = false; note(ts.parentNode.parentNode, CLOSED_MSG, true); blockCheckout(true); return; }
    var vals = Array.prototype.map.call(ts.options, function (o) { return +o.value; });
    var wantList = slotList(floorToday()).map(function (s) { return s.m; });
    var same = vals.length === wantList.length && vals.every(function (v, i) { return v === wantList[i]; });
    if (!same) fillTimes(ts, ts.getAttribute('data-r68-want') || ts.value || '720');
    note(ts.parentNode.parentNode, fullMsg(ts) || 'Thanksgiving pickup is Thursday, Nov 26, 11 AM to 6:45 PM. Same-day orders close at 2 PM.', false);
  }
  /* menu page setup sheet (cg-menu.js) */
  function applySetup() {
    var su = document.querySelector('.cgm-setup.is-open'); if (!su || !tgCart) return;
    var asap = su.querySelector('input[name="cgm-when"][value="asap"]');
    if (asap) { var lab = asap.closest('label') || asap.parentNode; if (lab) lab.style.display = 'none'; }
    var later = su.querySelector('input[name="cgm-when"][value="later"]');
    if (later && !later.checked) { later.checked = true; later.dispatchEvent(new Event('change', { bubbles: true })); }
    var ds = su.querySelector('[data-date]'), ts = su.querySelector('[data-time]');
    if (!ds || !ts || ts.__cgR68) return;
    var st = tgState();
    if (st !== 'open') { note(su.querySelector('.cgm-setup__body') || su, CLOSED_MSG, true); blockCheckout(true); return; }
    var hasDate = false;
    Array.prototype.slice.call(ds.options).forEach(function (o) { if (o.value === TG.date) hasDate = true; else if (o.value) o.remove(); });
    if (!hasDate) { var o = document.createElement('option'); o.value = TG.date; o.textContent = 'Thu, Nov 26 (Thanksgiving Day)'; ds.appendChild(o); }
    if (ds.value !== TG.date) { ds.value = TG.date; ds.dispatchEvent(new Event('change', { bubbles: true })); return; }
    var vals = Array.prototype.map.call(ts.options, function (o) { return +o.value; });
    var wantList = slotList(floorToday()).map(function (s) { return s.m; });
    var same = vals.length === wantList.length && vals.every(function (v, i) { return v === wantList[i]; });
    if (!same) {
      var keep = ts.value || '720';
      fillTimes(ts, keep);
      ts.dispatchEvent(new Event('change', { bubbles: true }));
    }
    note(su.querySelector('.cgm-setup__body') || ts.parentNode.parentNode, fullMsg(ts) || 'Thanksgiving pickup is Thursday, Nov 26, 11 AM to 6:45 PM. Same-day orders close at 2 PM.', false);
  }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.matches) return;
    if (t.matches('[data-time]') && !t.__cgR68) t.setAttribute('data-r68-want', t.value);
  }, true);
  function bootTG() {
    var sheet = document.getElementById('cgoc-sheet');
    if (sheet) {
      new MutationObserver(function () { if (!sheet.hidden) refreshTG().then(function () { setTimeout(function () { applySheet(sheet); }, 60); }); })
        .observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
      var ts = sheet.querySelector('[data-time]');
      if (ts) new MutationObserver(function () { if (!ts.__cgR68) setTimeout(function () { applySheet(sheet); }, 0); }).observe(ts, { childList: true });
    }
    var mt;
    new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(applySetup, 80); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (tgCart && tgState() !== 'open') blockCheckout(true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.cg-r68-blocked');
      if (!b) return;
      e.preventDefault(); e.stopImmediatePropagation();
      alert(CLOSED_MSG);
    }, true);
  }

  /* ---------- 3. UTM capture ---------- */
  var UKEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid'];
  function readUtm() { try { return JSON.parse(ls.get('cg_utm') || '{}'); } catch (e) { return {}; } }
  (function capture() {
    var q = new URLSearchParams(location.search), hit = {}, any = false;
    UKEYS.forEach(function (k) { var v = q.get(k); if (v) { hit[k] = v.slice(0, 200); any = true; } });
    if (!any) return;
    hit.landing_page = location.pathname; hit.captured_at = new Date().toISOString();
    ls.set('cg_utm', JSON.stringify(hit));
    if (!ls.get('cg_utm_first')) ls.set('cg_utm_first', JSON.stringify(hit));
  })();
  function utmAttrs() {
    var u = readUtm(), a = {};
    UKEYS.concat(['landing_page']).forEach(function (k) { if (u[k]) a['_' + k] = u[k]; });
    return a;
  }
  var utmSynced = false;
  function syncUtm(cart) {
    var a = utmAttrs(); if (!Object.keys(a).length) return;
    var p = cart ? Promise.resolve(cart) : getCart();
    p.then(function (c) {
      if (!c || !c.item_count) return;
      var cur = c.attributes || {}, diff = Object.keys(a).some(function (k) { return cur[k] !== a[k]; });
      if (diff) return postJSON('/cart/update.js', { attributes: a }).then(function () { utmSynced = true; });
      utmSynced = true;
    }).catch(function () {});
  }
  (function hookFetch() {
    var f = window.fetch; if (!f || f.__cgR68) return;
    var w = function (url, opts) {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      var p = f.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(u)) p.then(function () { setTimeout(function () { syncUtm(); }, 300); }).catch(function () {});
      return p;
    };
    Object.keys(f).forEach(function (k) { w[k] = f[k]; }); w.__cgR68 = true; window.fetch = w;
  })();
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelector) return;
    var act = (f.getAttribute('action') || '').toLowerCase();
    if (!/\/contact|\/account/.test(act) && !f.querySelector('[name^="contact["]')) return;
    var u = readUtm();
    UKEYS.concat(['landing_page']).forEach(function (k) {
      if (!u[k]) return;
      var n = 'contact[' + k + ']', i = f.querySelector('input[name="' + n + '"]');
      if (!i) { i = document.createElement('input'); i.type = 'hidden'; i.name = n; f.appendChild(i); }
      i.value = u[k];
    });
  }, true);
  window.CGUtm = { get: readUtm, attrs: utmAttrs };

  /* ---------- 4. GA4 gift card click ---------- */
  var ga4Ready = false;
  function ga4(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      if (typeof window.gtag !== 'function') window.gtag = function () { window.dataLayer.push(arguments); };
      if (!ga4Ready && C.ga4) { window.gtag('config', C.ga4, { send_page_view: false }); ga4Ready = true; }
      params = params || {}; if (C.ga4) params.send_to = C.ga4; params.transport_type = 'beacon';
      window.gtag('event', name, params);
      window.dataLayer.push({ event: name, link_url: params.link_url, page_path: location.pathname });
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href') || '';
    if (/toasttab\.com\/egiftcards|egiftcard|gift-card|giftcard/i.test(h)) {
      ga4('gift_card_click', { link_url: h, link_text: (a.textContent || '').trim().slice(0, 80), page_path: location.pathname });
    }
  }, true);

  /* ---------- 5. one rating everywhere ---------- */
  var R = C.rating || { value: '4.4', count: '2,200+' };
  function fixRatings(root) {
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) { var p = n.parentNode && n.parentNode.nodeName; return p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; } }), t, hits = [];
    while ((t = tw.nextNode())) { if (/\d,\d{3}\+?\s*(Google\s+)?reviews/i.test(t.nodeValue)) hits.push(t); }
    hits.forEach(function (n) { n.nodeValue = n.nodeValue.replace(/\d,\d{3}\+?(\s*)(Google\s+)?reviews/ig, function (m0, sp, g) { return R.count + sp + (g || '') + 'reviews'; }); });
    root.querySelectorAll('span').forEach(function (s) {
      if (s.__r68 || (s.textContent || '').trim() !== '★★★★★') return;
      var par = s.parentNode; if (!par || (par.textContent || '').indexOf(R.value) < 0) return;
      s.__r68 = 1; s.className += ' cg-r68-stars'; s.setAttribute('role', 'img'); s.setAttribute('aria-label', 'Rated ' + R.value + ' out of 5 on Google');
    });
  }

  /* ---------- 6. reorder ---------- */
  function reorder(items, btn) {
    items = (items || []).filter(function (i) { return i && i.id && i.q > 0; });
    if (!items.length) return;
    if (btn) { btn.disabled = true; btn.textContent = 'One sec…'; }
    var add = { items: items.map(function (i) { var o = { id: +i.id, quantity: +i.q }; if (i.p && typeof i.p === 'object' && Object.keys(i.p).length) o.properties = i.p; return o; }) };
    postJSON('/cart/clear.js', {}).then(function () { return postJSON('/cart/add.js', add); }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'add'); });
      try { localStorage.removeItem('cgm_setup_v1'); sessionStorage.removeItem('cg_time_ok'); } catch (e) {}
      syncUtm();
      location.href = '/cart';
    }).catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = 'Order again'; }
      alert('Some items from that order are not available right now, so we could not rebuild it. ' + (err && err.message ? '(' + err.message + ')' : ''));
    });
  }
  (function fromLink() {
    var q = new URLSearchParams(location.search), raw = q.get('cg_reorder'); if (!raw) return;
    var items = [];
    try { items = JSON.parse(raw.replace(/,\s*\]$/, ']')); } catch (e) {
      raw.split(',').forEach(function (p) { var x = p.split(':'); if (x[0]) items.push({ id: x[0], q: +(x[1] || 1) }); });
    }
    history.replaceState(null, '', location.pathname);
    reorder(items.map(function (i) { return { id: i.id || i.variant_id, q: i.q || i.quantity || 1, p: i.p || i.properties }; }));
  })();
  function orderAgainStrip() {
    var L = C.lastOrder; if (!L || !L.items || !L.items.length) return;
    if (!/^\/(pages\/food-menu-new|cart)\/?$/.test(location.pathname) || document.getElementById('cg-r68-again')) return;
    var d = document.createElement('div'); d.id = 'cg-r68-again'; d.className = 'cg-r68-again';
    d.innerHTML = '<div class="cg-r68-again__in"><p><b>Welcome back' + (L.first ? ', ' + String(L.first).replace(/[<>&"]/g, '') : '') + '.</b> Want your last order again? ' + L.summary.replace(/[<>&"]/g, '') + '</p><button type="button" data-go>Order again</button><button type="button" class="cg-r68-again__x" aria-label="Close">&times;</button></div>';
    d.querySelector('[data-go]').addEventListener('click', function () { reorder(L.items, this); });
    d.querySelector('.cg-r68-again__x').addEventListener('click', function () { d.remove(); try { sessionStorage.setItem('cg_r68_again', '1'); } catch (e) {} });
    try { if (sessionStorage.getItem('cg_r68_again')) return; } catch (e) {}
    document.body.appendChild(d);
    setTimeout(function () { if (d.parentNode) d.remove(); }, 15000);
  }
  window.CGReorder = reorder;

  /* ---------- 7. Klaviyo onsite after first interaction ---------- */
  function loadKlaviyo() {
    if (!C.klaviyo || window.__cgKl) return; window.__cgKl = true;
    var s = document.createElement('script'); s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=' + encodeURIComponent(C.klaviyo);
    s.onload = function () { try { if (C.customerEmail && window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: C.customerEmail }); } catch (e) {} };
    document.head.appendChild(s);
  }
  var evs = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  function onFirst() { evs.forEach(function (ev) { window.removeEventListener(ev, onFirst, { passive: true }); }); loadKlaviyo(); }
  evs.forEach(function (ev) { window.addEventListener(ev, onFirst, { passive: true }); });

  /* ---------- boot ---------- */
  function boot() {
    try { bootTG(); } catch (e) {}
    try { fixRatings(document.body); } catch (e) {}
    if (C.lastOrder) getCart().then(function (c) { if (!c.item_count) orderAgainStrip(); }).catch(function () {});
    syncUtm();
    if (!tgCart) refreshTG();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
